<template>
  <a-space v-if="hasMedia" class="links" :size="4">
    <!--para medias-->
    <a-tooltip v-if="media" title="Ver archivo de mensaje">
      <a @click.stop="handleShowMedia(media)">
        <PaperClipOutlined />
      </a>
    </a-tooltip>
    <!--para medias de mensajes de error-->
    <a-tooltip v-if="mediaWrongAnswer" title="Ver archivo de mensaje de error">
      <a @click.stop="handleShowMedia(mediaWrongAnswer)">
        <PaperClipOutlined />
      </a>
    </a-tooltip>
    <!--para medias de mensajes de transferencia-->
    <a-tooltip v-if="mediaTransfer" title="Ver archivo de mensaje de transferencia">
      <a @click.stop="handleShowMedia(mediaTransfer)">
        <PaperClipOutlined />
      </a>
    </a-tooltip>
  </a-space>
</template>
<script lang="ts" setup>
import { computed } from "vue";
import { PaperClipOutlined } from "@ant-design/icons-vue";
import { MediaNode } from "@/@types/chatbots";
import { formattedMedia } from "@/app/chatbots/utils/multimedia";
import type { UploadFile } from "ant-design-vue";

const props = defineProps<{
  dataSource: MediaNode;
}>();

const emits = defineEmits(["onPreview"]);

const hasMedia = computed(() => {
  if (!props.dataSource) return;
  return media.value || mediaWrongAnswer || mediaTransfer;
});

const media = computed(() => {
  return formattedMedia(props.dataSource, "media");
});

const mediaWrongAnswer = computed(() => {
  return formattedMedia(props.dataSource, "wrong_answer_media");
});

const mediaTransfer = computed(() => {
  return formattedMedia(props.dataSource, "transfer_queue_media");
});

const handleShowMedia = (mediaData: UploadFile | undefined) => {
  emits("onPreview", mediaData);
};
</script>
<style lang="sass" scoped></style>
